module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nlet preventFieldLabels = false;\nlet disabled = false;\nif(formMapping.fieldConfig){\nif(formMapping.fieldConfig.disabled){\ndisabled = true;\n}\n}\nif(formMapping.group){\n%><div class=\"group<%= (disabled ? ' disabled' : '') %><%- (formMapping.group !== true ? ' ' + formMapping.group : '')%>\"><%\nif(formMapping.labelKey){\npreventFieldLabels = true;\n%><%- include('label', { formMapping: formMapping, model: { label: storage.__(formMapping.labelKey) }}); %><%\n}\n}\nutils.forEach(formMapping.fields, function(field){\nif(disabled){\nfield.fieldConfig = field.fieldConfig || {};\nfield.fieldConfig.disabled = true;\n}\n%><%- include(field.type, { formMapping: field, model: model, config: { preventAllFieldLabels: preventFieldLabels || config.preventAllFieldLabels } }); %><%\n});\nif(formMapping.group){\n%></div><%\n}\n%>"
  , __filename = "..\\frontend-controller\\baseComponents\\bootstrap5\\form\\elements\\fieldGroup.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
let preventFieldLabels = false;
let disabled = false;
if(formMapping.fieldConfig){
if(formMapping.fieldConfig.disabled){
disabled = true;
}
}
if(formMapping.group){

    ; __line = 10
    ; __append("<div class=\"group")
    ; __append(escapeFn( (disabled ? ' disabled' : '') ))
    ; __append( (formMapping.group !== true ? ' ' + formMapping.group : ''))
    ; __append("\">")
    ; 
if(formMapping.labelKey){
preventFieldLabels = true;

    ; __line = 13
    ; __append( include('label', { formMapping: formMapping, model: { label: storage.__(formMapping.labelKey) }}) )
    ; 
}
}
utils.forEach(formMapping.fields, function(field){
if(disabled){
field.fieldConfig = field.fieldConfig || {};
field.fieldConfig.disabled = true;
}

    ; __line = 21
    ; __append( include(field.type, { formMapping: field, model: model, config: { preventAllFieldLabels: preventFieldLabels || config.preventAllFieldLabels } }) )
    ; 
});
if(formMapping.group){

    ; __line = 24
    ; __append("</div>")
    ; 
}

    ; __line = 26
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\frontend-controller\baseComponents\bootstrap5\form\elements\fieldGroup.ejs

}